var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 22.9219C27.6172 22.9219 26.0352 24.5039 26.0352 26.4492C26.0352 28.3945 27.6172 29.9766 29.5625 29.9766C31.5078 29.9766 33.0898 28.3945 33.0898 26.4492C33.0898 24.5039 31.5078 22.9219 29.5625 22.9219ZM29.5625 28.6875C28.332 28.6875 27.3242 27.6797 27.3242 26.4492C27.3242 25.2188 28.332 24.2109 29.5625 24.2109C30.793 24.2109 31.8008 25.2188 31.8008 26.4492C31.8008 27.6797 30.793 28.6875 29.5625 28.6875ZM14.9141 22.9219C12.9687 22.9219 11.3867 24.5039 11.3867 26.4492C11.3867 28.3945 12.9687 29.9766 14.9141 29.9766C16.8594 29.9766 18.4414 28.3945 18.4414 26.4492C18.4414 24.5039 16.8594 22.9219 14.9141 22.9219ZM14.9141 28.6875C13.6836 28.6875 12.6758 27.6797 12.6758 26.4492C12.6758 25.2188 13.6836 24.2109 14.9141 24.2109C16.1445 24.2109 17.1523 25.2188 17.1523 26.4492C17.1523 27.6797 16.1445 28.6875 14.9141 28.6875ZM36.0781 6.91406H8.43359L6.23047 1.37109L6.10156 1.04297L5.63281 0.960938L0.0546875 0.0234375V3.1875L5.22266 2.32031L12.5938 20.8945L12.7578 21.3047H32.3516L32.4922 20.8594L36.6875 7.75781L36.957 6.91406H36.0781ZM31.4141 20.0156H13.625L8.9375 8.20313H35.1875L31.4141 20.0156Z",
    fill: "#008F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.28e9fa4798bbe4dd73c297b9ab761fa9.svg";
export { ForwardRef as ReactComponent };